<template>
  <!-- <div style="position: absolute;width:100%;margin-top:150px;">
    <div class="ad-container">
      <Adsense
          data-ad-client="ca-pub-6699354447815429" 
          data-ad-slot="8230887469"
          data-ad-format="horizontal"
          data-full-width-responsive="true">
      </Adsense>
    </div>
  </div> -->
  <div class="hasoyeon-container" :key="sosoceoKey">
    <br>
    <br>
    <br>
    <div v-if="this.api.getCookies('login') === 'true' || this.api.getCookies('login') === true"> 
      <div v-if="pageParam === undefined" class="input-area">
        <div class="panel-header">
          <div class="current-player">
            <span class="player-badge">👤 {{ this.api.getCookies('mail') }}</span>
            <span class="record-badge"> 평균:{{ aver }}</span>
            <span class="record-badge"> 성공:{{ win }} 실패:{{ loss }} </span>
            <span class="record-badge"> 승률:{{ rate }}%</span>
          </div>
        </div>
        
        <br>
        <div class="modal-content game-start-popup-overlay">
          <div class="modal-body main-message">
            ⚾ <strong>세 자리 숫자 맞추기!!</strong> <br>
            <span style="font-size:1.1rem">게임은 라이브 방송을<br>보시면서 하셔야 됩니다!!</span><br><br>
            <a :href="youtubeUrl" target="_blank"><p class="popup-player">&gt;&gt;&gt; <strong>방송보러가기</strong> &lt;&lt;&lt;</p>  </a>
          </div>
          <div class="modal-footer">
            <button @click="click({type:'SELECT_GAME_RANK'})" class="btn-cancel">순위?</button>
            <button @click="click({type:'updateWaitingQueue'})" class="btn-confirm">도전!</button>
          </div>
        </div>
      </div>

      <div v-else-if="pageParam === 'baseball'" class="input-area ">
        <!-- 기존 baseball 화면 그대로 유지 -->
        <div class="notice-message" v-if="guessHistory.length === 0">
          ⚾ 실시간 숫자 야구! <br><span style="font-size:1.1rem">중복 없는 3자리 숫자를 먼저 맞혀보세요!</span>
        </div>
        <div v-else class="active-game-state">
          <div class="guess-log-container">
            <div class="log-header">
              <span>📜 <strong>시도 기록 (최근 {{ guessHistory.length }}회)</strong></span>
              <span class="attempts-badge">{{ guessHistory.length }} / 10</span>
            </div>
            <div class="guess-log">
              <div
                v-for="(entry, index) in guessHistory"
                :key="index"
                class="log-row"
                :class="{ 'latest': index === guessHistory.length - 1 }"
              >
                <div class="guess-number">{{ entry.guess }}</div>
                <div class="result-badges">
                  <span v-if="entry.s > 0" class="badge strike">{{ entry.s }}S</span>
                  <span v-if="entry.b > 0" class="badge ball">{{ entry.b }}B</span>
                  <span v-if="entry.s === 0 && entry.b === 0" class="badge out">OUT</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 30초 타이머 (wserver.vue와 동일 기능/기준 적용) -->
          <div class="timer-section">
            <div class="timer-header">
              <span class="timer-label">⏱ 다음 입력까지 남은 시간</span>
              <span class="timer-value" :class="{ danger: timeLeft < 10 }">{{ Math.ceil(timeLeft) }}초</span>
            </div>
            <div class="progress-bar-wrapper">
              <div 
                class="progress-bar" 
                :style="{ width: (timeLeft / 30 * 100) + '%' }" 
                :class="{ danger: timeLeft < 10 }"
              ></div>
            </div>
            <div class="input-prompt">
              <p v-if="timeLeft > 0">🔢 <strong>3자리 숫자</strong>를 30초 안에 입력해주세요!</p>
              <p v-else class="danger-text">⏰ 시간이 초과되었습니다. 서버에서 게임이 종료될 수 있습니다.</p>
            </div>
          </div>
        </div>

        <br>
        <div class="input-wrapper">
          <input 
            v-model="inputText" 
            @keyup.enter="send({page:pageParam})"
            type="number" 
            placeholder="예) 123, 456 (중복X)" 
            maxlength="3" 
            :disabled="timeLeft <= 0"
          />
          <button 
            @click="send({page:pageParam})" 
            :disabled="String(inputText).length !== 3 || timeLeft <= 0"
          >던지기 ⚾</button>
        </div>
        <div v-if="timeLeft <= 0 && guessHistory.length > 0" class="timeout-warning">
          ⚠️ 30초 제한 시간이 초과되었습니다. 다음 게임을 기다려주세요.
        </div>
      </div>

      <div v-else-if="pageParam === 'thirty'" class="input-area">
        <!-- 기존 thirty 화면 그대로 유지 -->
        <div class="notice-message">
          💬 다른 사람들은 무슨 말을 하고 있을까? <a href="https://youtube.com/@sosoceo" target="_blank" class="youtube-link">https://youtube.com/@sosoceo</a>
        </div>
        <br>
        <div class="input-wrapper">
          <input 
            v-model="inputText" 
            @keyup.enter="send({page:pageParam})"
            type="text" 
            placeholder="마음껏 털어놓으세요!" 
            maxlength="200" 
          />
          <button @click="send({page:pageParam})" :disabled="!String(inputText).trim()">외치기</button>
        </div>
        <div class="char-counter">
          {{ String(inputText).length }} / 200
        </div>
      </div>
    </div>

    <div v-else>
      <login @login="login" pageKey="sosoceo" /> 
    </div>

    <!-- 일반 모달 -->
    <transition name="modal-fade">
      <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content game-start-popup-overlay">
          <div class="modal-header">
            <h3>{{ modalTitle }}</h3>
          </div>
          <div class="modal-body">
            <p>{{ modalMsg }}</p  >
          </div>  
          <div class="modal-footer" v-if="this.modalTitle === '정답'" >
            <button class="btn-cancel" @click="click({type:'reset'})">{{ $t('menu.close') }}</button>
            <button class="btn-confirm" @click="click({type:'reset'})">순위보기</button>
          </div>
          <div class="modal-footer" v-else-if="this.modalTitle === '게임시작'" >
            <button class="btn-cancel" @click="closeModal">시작하기</button>
            <button class="btn-confirm" @click="goToYoutube">방송보기</button>
          </div>
          <div class="modal-footer" v-else-if="this.modalTitle === '게임종료' || this.modalTitle === '게임실패' || this.modalTitle === '플레이 중' || this.modalTitle === '시간 초과'" >
            <button class="btn-cancel" @click="click({type:'reset'})">{{ $t('menu.close') }}</button>
            <button class="btn-confirm" @click="goToYoutube">방송보기</button>
          </div>
          <div class="modal-footer" v-else >
            <button class="btn-cancel" @click="closeModal">{{ $t('menu.close') }}</button>
            <button class="btn-confirm" @click="goToYoutube">방송보기</button>
          </div>
        </div>
      </div>
    </transition>

    <!-- 순위 모달 (수정 완료) -->
    <transition name="modal-fade">
      <div v-if="showRankingModal" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content ranking-modal">
          <div class="modal-header">
            <h3>🏆 순위</h3>
          </div>
          <div class="modal-body">

            <!-- 탭 -->
            <div class="ranking-tabs">
              <button 
                class="tab-btn" 
                :class="{ active: activeTab === 'wins' }"
                @click="changeTab('wins')"
              >승</button>
              <button 
                class="tab-btn" 
                :class="{ active: activeTab === 'winrate' }"
                @click="changeTab('winrate')"
              >승률</button>
              <button 
                class="tab-btn" 
                :class="{ active: activeTab === 'aver' }"
                @click="changeTab('aver')"
              >평균</button>
            </div>

            <!-- 검색 -->
            <div class="input-wrapper" style="margin-bottom: 14px; padding: 6px 10px; ">
              <input 
                ref="searchTerm"
                type="text" 
                v-on:keyup.enter="click({type:'SELECT_GAME_RANK_BY_ID'})" 
                placeholder="아이디로 검색"
                style="padding: 11px 16px; font-size: 0.95rem;"
              />
              <button @click="click({type:'SELECT_GAME_RANK_BY_ID'})" class="btn-confirm">검색</button>
            </div>

            <!-- ==================== 흰색 테마로 변경된 랭킹 리스트 ==================== -->
            <div class="ranking-list-light">
              <div v-if="pagedRankings.length === 0" style="text-align:center; padding: 30px 10px; color:#888;">
                {{ $t('sentence.noResult') }}
              </div>
              <div v-else  
                v-for="(player, index) in pagedRankings" 
                :key="player.id"
                class="ranking-row-light"
              >
              <!-- 순위 -->
                <div v-if="searchTerm" style="display: flex; align-items: center; gap: 10px; width: 100%; ">
                  <!-- 아이디 -->
                  {{ player.RANK }}
                  <div v-if="player.ID === this.api.getCookies('mail')" style="flex: 1; font-size: 0.92rem; color: blue; font-weight: bolder; word-break: break-all;">
                    {{  player.ID }}
                  </div>
                  <div v-else style="flex: 1; font-family: 'Courier New', monospace; font-size: 0.92rem; color: #334155; word-break: break-all;">
                    {{ this.maskId(this.maskEmail(player.ID)) }}
                  </div>
                  <!-- 전적 배지 (흰 배경에 맞춰 색상 조정) -->
                  <div style="display: flex; gap: 5px; flex-shrink: 0;">
                    <span v-if="activeTab === 'wins'" class="record-badge" 
                          style="background: #fef08c; color: #713f12; font-size: 0.72rem; padding: 2px 8px; border: 1px solid #fde047;">
                      {{ player.VAL1 }}
                    </span>
                    <!-- <span class="record-badge" 
                          style="background: #fee2e2; color: #991b1b; font-size: 0.72rem; padding: 2px 8px; border: 1px solid #fecaca;">
                      {{ player.VAL2 }}
                    </span> -->
                    <span v-if="activeTab === 'winrate'" class="record-badge" 
                          style="background: #dcfce7; color: #166534; font-size: 0.72rem; padding: 2px 8px; border: 1px solid #bbf7d0;">
                      {{ parseFloat(player.VAL1 / (player.VAL1 + player.VAL2) * 100).toFixed(2) }}%
                    </span>
                    <span v-if="activeTab === 'aver'" class="record-badge" 
                          style="background: #fee2e2; color: #991b1b; font-size: 0.72rem; padding: 2px 8px; border: 1px solid #fecaca;">
                      {{ parseFloat(player.VAL3).toFixed(2) }}
                    </span>
                  </div>
                </div>
                <div v-else style="display: flex; align-items: center; gap: 10px; width: 100%;">
                  <div >{{ (currentPage - 1) * 10 + (index + 1) }}</div>
                  
                  <!-- 아이디 -->
                  <div v-if="player.ID === this.api.getCookies('mail')" style="flex: 1; font-size: 0.92rem; color: blue; font-weight: bolder; word-break: break-all;">
                    {{  player.ID }}
                  </div>
                  <div v-else style="flex: 1; font-family: 'Courier New', monospace; font-size: 0.92rem; color: #334155; word-break: break-all;">
                    {{ this.maskId(this.maskEmail(player.ID)) }}
                  </div>

                  <!-- 전적 배지 (흰 배경에 맞춰 색상 조정) -->
                  <div style="display: flex; gap: 5px; flex-shrink: 0;">
                    <span v-if="activeTab === 'wins'" class="record-badge" 
                          style="background: #fef08c; color: #713f12; font-size: 0.72rem; padding: 2px 8px; border: 1px solid #fde047;">
                      {{ player.VAL1 }}
                    </span>
                    <span v-if="activeTab === 'winrate'" class="record-badge" 
                          style="background: #dcfce7; color: #166534; font-size: 0.72rem; padding: 2px 8px; border: 1px solid #bbf7d0;">
                      {{ parseFloat(player.VAL1 / (player.VAL1 + player.VAL2) * 100).toFixed(2) }}%
                    </span>
                    <span v-if="activeTab === 'aver'" class="record-badge" 
                          style="background: #fee2e2; color: #991b1b; font-size: 0.72rem; padding: 2px 8px; border: 1px solid #fecaca;">
                      {{ parseFloat(player.VAL3).toFixed(2) }}
                    </span>
                    <!-- <span class="record-badge" 
                          style="background: #fee2e2; color: #991b1b; font-size: 0.72rem; padding: 2px 8px; border: 1px solid #fecaca;">
                      {{ player.losses }}
                    </span> -->
                  </div>
                </div>
              </div>


            </div>
            <!-- ====================================================================== -->


            <!-- 페이징 -->
            <div v-if="totalPages > 1 && this.searchTerm === ''" style="display: flex; justify-content: center; align-items: center; gap: 10px; margin-top: 6px;">
              <button 
                @click="prevPage" 
                :disabled="currentPage === 1"
                class="btn-confirm"
                style="padding: 6px 14px; font-size: 0.85rem; flex: none;"
              >◀</button>
              
              <span style="font-size: 0.85rem; color: #555; min-width: 70px; text-align: center; font-weight: 600;">
                {{ currentPage }} / {{ totalPages }}
              </span>
              
              <button 
                @click="nextPage" 
                :disabled="currentPage === totalPages"
                class="btn-confirm"
                style="padding: 6px 14px; font-size: 0.85rem; flex: none;"
              >▶</button>
            </div>

            <div style="text-align: center; font-size: 0.7rem; color: #999; margin-top: 8px;">
              총 {{ filteredAndSortedRankings.length }}명
            </div>

          </div>
          <div class="modal-footer">
            <button class="btn-cancel" @click="closeModal">{{ $t('menu.close') }}</button>
          </div>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
import { ref, inject } from 'vue'
import ssr from './components/common/ssr'
import login from '@/components/common/Login.vue'

const page = 'sosoceo'

export default {
  name: page,
  emits: ["setMenu", "login", "logout"],
  
  setup() {
    const setMeta = inject('setMeta')
    const title = 'GEEK9 > SoSoCEO'
    const keywords = '실시간 스트리밍 커뮤니케이터'
    const description = '시간 때우기'
    const geek9Url = 'https://www.youtube.com/@sosoceo'
    const inputText = ref(undefined)
    const showModal = ref(false)
    const showRankingModal = ref(false)

    let pageParam = ref(undefined)
    let modalTitle = ref('')
    let modalUrl = ref('')
    let modalMsg = ref('당신의 이야기가 무사히 전달되었습니다.\n다른 사람들의 이야기도 확인해 볼까요?')

    setMeta({
      title: title,
      keywords: keywords,
      description: description,
      'og:title': title,
      'og:description': description,
      'og:image': 'https://geek9.kr/img/favicon.png',
      'og:url': geek9Url,
      'canonical': geek9Url
    })
    
    const addJsonLd = () => {
      let flag = true
      document.querySelectorAll('script').forEach(el => {
        if (el.getAttribute('type') === 'application/ld+json' ) {
          flag = false
          return
        }
      })
      if(flag === true) {
        const script = document.createElement('script')
        script.setAttribute('type', 'application/ld+json')
        script.textContent = JSON.stringify(
          {
            "@context": "https://schema.org",
            "@graph": [
              ssr.getWebPage(geek9Url, title, ssr.GEEK9_URL+"biz", description)
            ]
          }
        )
        document.head.appendChild(script)
      }
    }
    return {
      addJsonLd, inputText, showModal, showRankingModal, modalTitle, modalUrl, modalMsg, pageParam
    }
  },  
  
  computed: {
    filteredAndSortedRankings() {
      let list = this.rankings.map(item => {
        const total = (item.VAL1 || 0) + (item.VAL2 || 0)
        const winRate = total > 0 
          ? parseFloat(((item.VAL1 / total) * 100).toFixed(2)) 
          : 0
        return { ...item, winRate }
      })

      // 검색 필터
      // if (this.searchTerm && this.searchTerm.trim()) {
      //   const term = this.searchTerm.toLowerCase().trim()
      //   list = list.filter(item => 
      //     item.ID && item.ID.toLowerCase().includes(term)
      //   )
      // }

      // 탭별 정렬 (서버에서 이미 정렬되어 오지만, 검색 후 재정렬용)
      if (this.activeTab === 'winrate') {
        list.sort((a, b) => b.winRate - a.winRate || b.VAL1 - a.VAL1)
      } else if (this.activeTab === 'wins') {
        list.sort((a, b) => b.VAL1 - a.VAL1 || b.winRate - a.winRate)
      } else if (this.activeTab === 'aver') {
        list.sort((a, b) => a.VAL3 - b.VAL3 || b.VAL1 - a.VAL1)
      }

      return list
    },

    pagedRankings() {
      // ★ 서버 페이지네이션 사용 중이므로 slice 제거
      // 검색어가 있으면 필터링된 결과 사용, 없으면 rankings 그대로
      return this.filteredAndSortedRankings
    },

  },

  mounted() {
    const paramPage = this.$route.query.page
    if(paramPage === 'baseball') {
      this.modalTitle = '게임시작'
      this.modalMsg = '라이브 영상으로 게임을 시청하세요!'
      this.showModal = true
    }
    this.emitter.on('sosoceoReload', this.reload)
    this.addJsonLd()
    this.api.setPage(page)
    this.pageParam = this.$route.query.page
    this.$emit("setMenu", {page:page})
    this.search({type:"SELECT_AUTOMATE", gameType:"baseball"})
    this.search({type:"SELECT_BASEBALL"})
    // this.handleBeforeUnload = this.handleBeforeUnload.bind(this)
    // window.addEventListener('beforeunload', this.handleBeforeUnload)
    // window.addEventListener('pagehide', this.handleBeforeUnload) // ← 추가
    // navigator.sendBeacon('localhost:4000/websocket?type=removeWaitingQueue', JSON.stringify({type:'removeWaitingQueue', id:this.api.getCookies('mail'), page: 'baseball'}));
    // window.addEventListener('unload', () => {
    //   // 브라우저가 닫히기 직전에 데이터를 보낼 때 사용
    //   navigator.sendBeacon('localhost:4000/websocket?type=removeWaitingQueue', JSON.stringify({type:'removeWaitingQueue', id:this.api.getCookies('mail'), page: 'baseball'}));
    // });

    window.addEventListener('beforeunload', this.handleBeforeUnload);
      // 라우터 이동 등을 감지하여 플래그 활성화 (예시)
    window.addEventListener('click', (e) => {
      if (e.target.tagName === 'A') this.isNavigating = true;
    })
  },

  beforeUnmount() {
    this.stopTurnTimer()
    // window.removeEventListener('beforeunload', this.handleBeforeUnload)
    // this.handleBeforeUnload()
  },
  
  unmounted() {
    this.stopTurnTimer()
    // window.removeEventListener('beforeunload', this.handleBeforeUnload)
    // window.removeEventListener('pagehide', this.handleBeforeUnload)
    // window.removeEventListener('unload', this.handleBeforeUnload)
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  
  components: {
    login
  },
  
  data(){
    return{
      isNavigating: false,
      youtubeUrl: undefined,
      win: undefined,
      loss: undefined,
      aver: undefined,
      rate: undefined,
      totalPages: 1,
      rankings: [],
      activeTab: 'wins',
      sosoceoKey: -1,
      guessHistory: [],
      currentPage: 1,
      searchTerm: '',
      // === 30초 타이머 (wserver.vue와 동일) ===
      timeLeft: 30,
      progressTimer: null,
      turnStartTime: null,
    }
  },
  
  methods: {
    async handleBeforeUnload(event) {
      if (!this.isNavigating) {
        // event.preventDefault();
        event.returnValue = '' // 최신 브라우저에서는 필수
        this.api.axiosGql('removeWaitingQueue', {type:'removeWaitingQueue', id:this.api.getCookies('mail'), page: 'baseball'})
      }
    },

    // === 30초 타이머 메서드 (wserver.vue와 완전히 동일한 로직) ===
    stopTurnTimer() {
      if (this.progressTimer) { 
        clearInterval(this.progressTimer) 
        this.progressTimer = null 
      }
      this.turnStartTime = null
    },

    startTurnTimer() {
      this.stopTurnTimer()
      this.turnStartTime = Date.now()
      this.timeLeft = 30
      this.progressTimer = setInterval(() => {
        if (!this.turnStartTime || this.pageParam !== 'baseball') { 
          this.stopTurnTimer() 
          return 
        }
        const elapsed = (Date.now() - this.turnStartTime) / 1000
        this.timeLeft = Math.max(0, 30 - elapsed)
        if (this.timeLeft <= 0) { 
          this.stopTurnTimer() 
          this.handleTimeOut()
        }
      }, 100)
    },

    handleTimeOut() {
      // 클라이언트 UX용. 실제 게임 종료는 wserver.vue의 타이머가 서버에 전달
      if (this.modalTitle !== '정답' && this.modalTitle !== '게임실패' && this.modalTitle !== '게임종료') {
        this.modalTitle = '시간 초과'
        this.modalMsg = '30초 내에 숫자를 입력하지 않았습니다.\n서버에서 게임이 종료 처리될 수 있습니다.'
        this.showModal = true
      }
    },

    // handleNavigation() {
    //   this.isNavigating = true
    // },
    // async handleBeforeUnload() {
    //   await this.api.axiosGql('removeWaitingQueue', {type:'removeWaitingQueue', id:this.api.getCookies('mail'), page: 'baseball'})
    //   // navigator.sendBeacon('localhost:4000/websocket?type=removeWaitingQueue', JSON.stringify({type:'removeWaitingQueue', id:this.api.getCookies('mail'), page: 'baseball'}));
    // },
    async search(param) {
      const type = param.type
      if(type === "SELECT_BASEBALL") {
        await this.api.axiosGql(type, {
          type:type, 
          id: this.api.getCookies('mail'), 
          page: 'baseball', 
        })
        .then( async (res) => {
          if(res.data && res.status === 200) {
            this.win = res.data.VAL1
            this.loss = res.data.VAL2
            this.aver = parseFloat(res.data.VAL3).toFixed(2)
            this.rate = parseFloat(this.win / (this.win + this.loss) * 100).toFixed(2)
          }
        })
        .catch( (err) => {
          console.log(err)
        })
      } else if(type === 'SELECT_GAME_RANK') {
        if(this.showRankingModal === false) {
          this.searchTerm = ''
          this.currentPage = 1
          this.rankings = []
        }
        await this.api.axiosGql(type, param) 
        .then( async (res) => {
          if(res.data && res.status === 200) {
            this.rankings = res.data.items || []
            this.totalPages = res.data.totalPages || 1     // ← 핵심 수정
            if(this.showRankingModal === false) {
              this.showRankingModal = true
            }
          }
        })
        .catch( (err) => {
          console.log(err)
        })
      } else if(type === 'SELECT_AUTOMATE') {
        await this.api.axiosGql(type, {type:type, gameType:'baseball'}) 
        .then( async (res) => {
          if(res.data && res.status === 200) {
            this.youtubeUrl = res.data.CONTENT
          }
        })
        .catch( (err) => {
          console.log(err)
        })
      }
    },
    
    async click(param) {
      const type = param.type
      if(type === "updateWaitingQueue") {
        await this.api.axiosGql(type, {
          type: type,
          page: 'baseball',
          id: this.api.getCookies('mail'),
          win: this.win,
          loss: this.loss,
          aver: this.aver,
          rate: this.rate
        })
        .then ( async (res) => {
          if(res.status === 200) {
            const link = document.createElement('a')
            link.href = 'https://geek9.kr/sosoceo?page=baseball'
            // link.href = 'http://localhost:3000/sosoceo?page=baseball'
            document.body.appendChild(link)
            link.click()
          }
        })
      } else if(type === "SELECT_GAME_RANK") {
        this.activeTab = 'wins'
        this.searchTerm = ''
        this.currentPage = 1

        await this.search({type:type, 
          page:this.currentPage, 
          gameType:'baseball', 
          subType:this.activeTab})
      } else if(type === 'SELECT_GAME_RANK_BY_ID') {
        if(this.$refs.searchTerm.value && String(this.$refs.searchTerm.value).length > 2) {
          this.searchTerm = this.$refs.searchTerm.value
          this.currentPage = 1
          await this.search({
            type:'SELECT_GAME_RANK', 
            id:this.searchTerm,
            page:this.currentPage, 
            gameType:'baseball', 
            subType:this.activeTab
          })
        } else {
          alert('검색어를 세 글자 이상 입력해주세요')
        }
      } else if(type === 'reset') {
        this.stopTurnTimer()
        const link = document.createElement('a')
        link.href = '/sosoceo'
        document.body.appendChild(link)
        link.click()
        // await this.search({
        //   type:'SELECT_GAME_RANK', 
        //   page:this.currentPage, 
        //   gameType:'baseball', 
        //   subType:this.activeTab
        // })
      }
    },
    // async searchRank(param) {
    //   const type  = param.type
    //   return this.api.axiosGql(type, param) 
    // },    
    reload(flag) {
      if(flag === 'dashboard') {
        this.sosoceoKey++
        // this.$emit("setMenu", {page:'sosoceo'})
        this.addJsonLd()
        this.search({type:"SELECT_BASEBALL"})
      }
    },
    
    login() {
      this.$emit('login')
    },
    
    async send(param) {
      const page = param.page
      const val = String(this.inputText).trim()
      if(this.guessHistory.length === 10) {
        this.modalTitle = '게임실패'
        this.modalMsg = `10회 시도 제한에 도달했습니다.`
        this.showModal = true
        this.stopTurnTimer()
        return
      } else if (!val) return

      if(page === 'baseball') {
        if (!/^\d{3}$/.test(val)) {
          alert("3자리 숫자를 입력해주세요!")
          this.inputText = undefined
          return
        }
        const uniqueDigits = new Set(val.split(''))
        if (uniqueDigits.size !== 3) {
          alert("중복되지 않는 3개의 숫자를 입력해주세요! (예: 123)")
          this.inputText = undefined
          return
        }
      } else if(page === 'thirty') {
        this.modalMsg = '당신의 이야기가 무사히 전달되었습니다.\n다른 사람들의 이야기도 확인해 볼까요?'
      }
      
      try {
        const result = await this.api.axiosGql(page, {
          type: page,
          page: page,
          message: String(this.inputText),
          id: this.api.getCookies('mail')
        })
        
        if (result.status === 200) {
          if (page === 'baseball') {
            const json = result.data
            console.log('@@@@@@@@@@@@@')
            console.log(json)
            if (json.s === 3) {
              this.guessHistory.push({
                guess: result.data.message || val,
                s: json.s,
                b: json.b,
                attempts: json.attempts
              })
              this.modalTitle = '정답'
              this.modalMsg = `"${json.target}" `
              this.showModal = true
              this.stopTurnTimer()
            } else if (json.error === '다른 플레이어가 게임 중 입니다') {
              this.modalTitle = '플레이 중'
              this.modalMsg = `${json.error}\n차례가 되면 숫자를 입력해주세요`
              this.showModal = true
            } else if (json.error !== "쿨다운") {
              this.guessHistory.push({
                guess: result.data.message || val,
                s: json.s,
                b: json.b,
                attempts: json.attempts
              })
              if(this.guessHistory.length === 10) {
                this.modalTitle = '게임실패'
                this.modalMsg = `10회 시도 제한에 도달했습니다.`
                this.showModal = true
                this.stopTurnTimer()
                return
              }
              // === wserver.vue와 동일 기준으로 타이머 시작 (이전 결과 확인 후 다음 입력까지 30초) ===
              this.startTurnTimer()
            }
          }
        } else if(result.status === 201) {
          this.modalTitle = '게임종료'
          this.modalMsg = `게임이 종료되었습니다.
          다시 도전해주세요!`
          this.showModal = true
          this.stopTurnTimer()
          // const link = document.createElement('a')
          // link.href = '/sosoceo'
          // document.body.appendChild(link)
          // link.click()
        }
        this.inputText = undefined
      } catch (err) {
        console.log(err)
        this.modalMsg = '방송전 입니다'
      }
    },
    
    closeModal() {
      this.showModal = false
      this.showRankingModal = false
      // 모달 닫힌 후에도 타이머는 유지 (게임 진행 중)
    },
    
    goToYoutube() {
      window.open('https://youtube.com/@sosoceo', '_blank')
      this.closeModal()
    },
    
    // ===== 순위 모달용 메서드 =====
    async changeTab(tab) {
      this.$refs.searchTerm.value = ''
      this.searchTerm = ''
      this.currentPage = 1
      this.activeTab = tab
      await this.search({
        type:'SELECT_GAME_RANK', 
        page:this.currentPage, 
        gameType:'baseball', 
        subType:this.activeTab})
    },
    
    resetPage() {
      this.currentPage = 1
    },
    
    async prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.searchTerm = ''
        await this.search({
          type:'SELECT_GAME_RANK', 
          page:this.currentPage, 
          gameType:'baseball', 
          subType:this.activeTab}
        )
      }
    },
    
    async nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
        this.searchTerm = ''
        await this.search({
          type:'SELECT_GAME_RANK', 
          page:this.currentPage, 
          gameType:'baseball', 
          subType:this.activeTab
      })
      }
    },

    maskId(id) {
      if (!id) return '익명'
      return id.length > 6 ? id.substring(0, 4) + '***' : id + '***'
    },

    maskEmail(email) {
      if (!email) return ''
      const parts = String(email).split('@')
      if (parts.length !== 2) return email
      // return `${parts[0]}@***`
      return `${parts[0]}`
    }
  }
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap');
  @import './assets/css/bootstrap.min.css';

  /* ============================================
     모든 스타일은 .hasoyeon-container 하위에만 적용되도록 수정
     ============================================ */

  .hasoyeon-container {
    box-sizing: border-box;
    font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: linear-gradient(135deg, #fdfbfb 0%, #faf3dd 100%);
    padding: 20px;
    color: #4a4a4a;
    position: relative; /* 모달 배치를 위한 relative 설정 */
  }

  /* 입력 영역 */
  .hasoyeon-container .input-area {
    width: 100%;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .hasoyeon-container .main-message {
    background: rgba(255, 255, 255, 0.7);
    width: auto;
    padding: 10px 20px;
    font-weight: bold;
    margin-bottom: 15px;
    font-size: 1.55rem;
    color: #666;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
    text-align: center;
    word-break: keep-all;
  }

  .hasoyeon-container .notice-message {
    background: rgba(255, 255, 255, 0.7);
    max-width: 300px;
    border: 1px solid rgba(255, 193, 7, 0.4);
    padding: 10px 20px;
    font-weight: bold;
    border-radius: 30px;
    margin-bottom: 15px;
    font-size: 1.55rem;
    color: #666;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
    text-align: center;
    word-break: keep-all;
  }

  .hasoyeon-container .youtube-link {
    color: #e0a800;
    font-weight: bold;
    text-decoration: none;
    transition: color 0.2s ease;
  }
  .hasoyeon-container .youtube-link:hover {
    color: #c69500;
    text-decoration: underline;
  }

  .hasoyeon-container .input-wrapper {
    width: 100%;
    display: flex;
    gap: 10px;
    background: white;
    padding: 10px;
    border-radius: 50px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  }

  .hasoyeon-container input {
    flex: 1;
    border: none;
    outline: none;
    padding: 15px 20px;
    font-size: 1rem;
    border-radius: 50px;
    background: transparent;
  }
  .hasoyeon-container input::placeholder {
    color: #ffc107;
  }

  /* 공통 버튼 스타일 (입력창 우측 버튼) */
  .hasoyeon-container .input-wrapper button {
    border: none;
    background: #ffc107;
    min-height: 40px;
    color: white;
    font-weight: bold;
    font-size: 1rem;
    padding: 0 25px;
    border-radius: 40px;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s;
    white-space: nowrap;
  }

  .hasoyeon-container .default-btn {
    border: none;
    background: #ffc107;
    min-height: 60px;
    color: white;
    font-weight: bold;
    font-size: 2rem;
    padding: 0 25px;
    border-radius: 40px;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s;
    white-space: nowrap;
  }
  .hasoyeon-container .default-btn:hover:not(:disabled) {
    background: #e0a800;
  }
  .hasoyeon-container .default-btn:active:not(:disabled) {
    transform: scale(0.95);
  }
  .hasoyeon-container .default-btn:disabled {
    background: #e0e0e0;
    cursor: not-allowed;
  }

  .hasoyeon-container .input-wrapper button:hover:not(:disabled) {
    background: #e0a800;
  }
  .hasoyeon-container .input-wrapper button:active:not(:disabled) {
    transform: scale(0.95);
  }
  .hasoyeon-container .input-wrapper button:disabled {
    background: #e0e0e0;
    cursor: not-allowed;
  }

  .hasoyeon-container .char-counter {
    width: 100%;
    text-align: right;
    font-size: 0.85rem;
    color: #999;
    margin-top: 8px;
    padding-right: 15px;
  }

  /* 게임 시작 팝업 오버레이 */
  .hasoyeon-container .game-start-popup-overlay {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 15, 35, 0.92);
    border-radius: 16px;
    animation: fadeInOverlay 0.2s ease;
  }

  /* 🎁 모달 (확인 창) 스타일 */
  .hasoyeon-container .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
  }

  .hasoyeon-container .modal-content {
    display: flex;
    flex-direction: column;
    max-height: calc(100dvh - 32px);  /* 동적 뷰포트 높이 사용 */
    overflow: hidden;
    background: white;
    width: 100%;
    max-width: 500px;
    border-radius: 24px;
    padding: 30px;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
    text-align: center;
  }

  .hasoyeon-container .modal-header h3 {
    margin: 0 0 15px 0;
    color: #333;
    font-size: 1.4rem;
    font-weight: bold;
  }

  .hasoyeon-container .modal-body {
    flex: 1 1 auto;
    overflow-y: auto;
    min-height: 0;                    /* flex에서 overflow가 제대로 동작하게 하는 핵심 */
    -webkit-overflow-scrolling: touch; /* iOS 부드러운 스크롤 */
  }

  .hasoyeon-container .modal-body p {
    margin: 5px 0;
    color: #666;
    font-size: 1.05rem;
    line-height: 1.5;
    word-break: keep-all;
  }

  .hasoyeon-container .modal-footer {
    display: flex;
    gap: 15px;
    margin-top: 25px;
    justify-content: center;
  }

  .hasoyeon-container .modal-footer button {
    margin-top: 25px;
    flex: 1;
    padding: 12px 0;
    border: none;
    border-radius: 40px;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s;
  }

  .hasoyeon-container .btn-cancel {
    background: #f1f3f5;
    color: #555;
  }
  .hasoyeon-container .btn-cancel:hover {
    background: #e2e6ea;
  }
  .hasoyeon-container .btn-cancel:active {
    transform: scale(0.95);
  }

  .hasoyeon-container .btn-confirm {
    background: #ffc107;
    color: white;
  }
  .hasoyeon-container .btn-confirm:hover {
    background: #e0a800;
  }
  .hasoyeon-container .btn-confirm:active {
    transform: scale(0.95);
  }

  /* 모달 트랜지션 애니메이션 */
  .hasoyeon-container .modal-fade-enter-active,
  .hasoyeon-container .modal-fade-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
  }
  .hasoyeon-container .modal-fade-enter-from,
  .hasoyeon-container .modal-fade-leave-to {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }

  /* 📱 모바일 대응 */
  @media (max-width: 800px) {
    .hasoyeon-container .notice-message {
      font-size: 0.85rem;
      padding: 8px 15px;
    }

    .hasoyeon-container .input-wrapper {
      flex-direction: column;
      border-radius: 25px;
      padding: 10px;
    }
    .hasoyeon-container input {
      font-size: 0.9rem;
      padding: 12px 15px;
    }
    .hasoyeon-container .char-counter {
      font-size: 0.8rem;
    }

    .hasoyeon-container .modal-content {
      padding: 25px 20px;
    }
    .hasoyeon-container .modal-header h3 {
      font-size: 1.25rem;
    }
    .hasoyeon-container .modal-body p {
      font-size: 0.95rem;
    }
    .hasoyeon-container .modal-footer {
      gap: 10px;
    }
    .hasoyeon-container .modal-footer button {
      font-size: 0.95rem;
      padding: 10px 0;
    }
  }

  /* 활성 게임 상태 */
  .hasoyeon-container .active-game-state {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  /* 추측 로그 컨테이너 */
  .hasoyeon-container .guess-log-container {
    flex: 0 0 auto;
    background: #0f0f23;
    border-radius: 12px;
    padding: 12px;
    margin-bottom: 16px;
    border: 1px solid #2a2a4a;
    max-height: none;
    overflow-y: visible;
  }

  .hasoyeon-container .log-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px 8px;
    font-size: 13px;
    color: #888;
    border-bottom: 1px solid #2a2a4a;
    margin-bottom: 8px;
  }

  .hasoyeon-container .attempts-badge {
    background: #3a2a1f;
    color: #ffaa00;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 700;
  }

  .hasoyeon-container .guess-log {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .hasoyeon-container .log-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #1a1a2e;
    padding: 10px 14px;
    border-radius: 8px;
    transition: all 0.2s;
  }

  .hasoyeon-container .log-row.latest {
    background: #2a2a3f;
    border: 1px solid #ffd700;
    box-shadow: 0 0 8px rgba(255, 215, 0, 0.3);
  }

  .hasoyeon-container .guess-number {
    font-family: 'Courier New', monospace;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 4px;
    color: #fff;
  }

  .hasoyeon-container .result-badges {
    display: flex;
    gap: 6px;
  }

  .hasoyeon-container .badge {
    padding: 4px 12px;
    border-radius: 999px;
    font-size: 14px;
    font-weight: 700;
  }

  .hasoyeon-container .badge.strike {
    background: #ff3b5c;
    color: white;
  }

  .hasoyeon-container .badge.ball {
    background: #00b8ff;
    color: white;
  }

  .hasoyeon-container .badge.out {
    background: #555;
    color: #ddd;
  }

  .hasoyeon-container .log-empty {
    text-align: center;
    color: #666;
    padding: 40px 0;
    font-size: 15px;
  }

  /* 패널 헤더 */
  .hasoyeon-container .panel-header {
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
  }

  .hasoyeon-container .panel-header h2 {
    margin: 0;
    font-size: 20px;
    color: #ffd700;
    flex-shrink: 0;
  }

  .hasoyeon-container .current-player {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .hasoyeon-container .player-badge,
  .hasoyeon-container .record-badge {
    background-color: #ffcc66;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    flex-shrink: 0;
  }

  /* 모바일 전용 스타일 */
  @media (max-width: 600px) {
    .hasoyeon-container .panel-header {
      padding: 12px 16px;
      align-items: flex-start;
    }

    .hasoyeon-container .current-player {
      gap: 6px;
      justify-content: flex-start;
      width: 100%;
    }

    .hasoyeon-container .player-badge,
    .hasoyeon-container .record-badge {
      font-size: 12.5px;
      padding: 3px 10px;
      flex-shrink: 1;
    }

    .hasoyeon-container .record-badge:last-child {
      font-size: 12px;
      padding: 3px 9px;
    }
  }

  /* 아주 작은 화면 (아이폰 SE 등) */
  @media (max-width: 380px) {
    .hasoyeon-container .current-player {
      gap: 5px;
    }

    .hasoyeon-container .player-badge,
    .hasoyeon-container .record-badge {
      font-size: 11.5px;
      padding: 2px 8px;
    }
  }

  /* ===== 순위 모달 전용 스타일 ===== */
  .hasoyeon-container .ranking-tabs {
    display: flex;
    gap: 8px;
    margin-bottom: 14px;
  }

  .hasoyeon-container .tab-btn {
    flex: 1;
    padding: 9px 0;
    font-size: 0.92rem;
    font-weight: 700;
    border: none;
    border-radius: 999px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: #f1f5f9;
    color: #475569;
  }

  .hasoyeon-container .tab-btn.active {
    background: #ffc107;
    color: white;
    font-weight: 800;
    box-shadow: 0 3px 10px rgba(255, 193, 7, 0.35);
  }

  .hasoyeon-container .rank-badge {
    background: linear-gradient(to right, #ffd54f, #ffb300);
    color: #3a2f00;
    font-weight: 800;
    font-size: 0.78rem;
    padding: 4px 11px;
    border-radius: 999px;
    min-width: 50px;
    text-align: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
  }

  /* 흰색 테마 랭킹 리스트 */
  .hasoyeon-container .ranking-list-light {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 6px;
    margin-bottom: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .hasoyeon-container .ranking-row-light {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 11px 14px;
    border-radius: 8px;
    margin-bottom: 4px;
    background: #f8fafc;
    transition: all 0.2s ease;
  }

  .hasoyeon-container .ranking-row-light:hover {
    background: #f1f5f9;
    transform: translateY(-1px);
  }

  .hasoyeon-container .ranking-row-light:last-child {
    margin-bottom: 0;
  }

  .hasoyeon-container .popup-player strong {
    font-size: 26px;
    color: #ffc107;
    text-decoration: underline;
    font-style: italic;
  }

  /* =====================================================
     30초 타이머 스타일 (wserver.vue와 동일 기능, 라이트 테마에 맞게 조정)
     ===================================================== */
  .hasoyeon-container .timer-section {
    background: #fff9e6;
    border: 2px solid #ffe082;
    border-radius: 14px;
    padding: 14px 18px;
    margin-bottom: 14px;
    box-shadow: 0 2px 10px rgba(255, 193, 7, 0.15);
  }

  .hasoyeon-container .timer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }

  .hasoyeon-container .timer-label {
    color: #5d4e37;
    font-size: 14px;
    font-weight: 600;
  }

  .hasoyeon-container .timer-value {
    font-size: 26px;
    font-weight: 800;
    color: #00c853;
    font-variant-numeric: tabular-nums;
    transition: color 0.2s ease;
  }

  .hasoyeon-container .timer-value.danger {
    color: #e53935;
    animation: pulse 1s infinite;
  }

  .hasoyeon-container .progress-bar-wrapper {
    height: 8px;
    background: #fff3cd;
    border-radius: 999px;
    overflow: hidden;
    margin-bottom: 10px;
    border: 1px solid #ffe082;
  }

  .hasoyeon-container .progress-bar {
    height: 100%;
    background: linear-gradient(90deg, #00c853, #ffd54f);
    transition: width 0.08s linear;
    border-radius: 999px;
  }

  .hasoyeon-container .progress-bar.danger {
    background: linear-gradient(90deg, #e53935, #ff8a65);
  }

  .hasoyeon-container .input-prompt {
    text-align: center;
    margin-top: 4px;
  }

  .hasoyeon-container .input-prompt p {
    margin: 4px 0;
    font-size: 14.5px;
    color: #5d4e37;
    font-weight: 500;
  }

  .hasoyeon-container .danger-text {
    color: #e53935 !important;
    font-weight: 700;
  }

  .hasoyeon-container .timeout-warning {
    margin-top: 8px;
    padding: 8px 14px;
    background: #ffebee;
    color: #c62828;
    font-size: 0.9rem;
    border-radius: 10px;
    text-align: center;
    border: 1px solid #ef9a9a;
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.35; }
  }

</style>